/**
 * Sleep for a certain amount of milliseconds
 */
export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
